class AlternatingTimeline {
  constructor(section) {
    this.section = section;
    this.timeline = section.querySelector('[data-timeline]');
    this.items = Array.from(section.querySelectorAll('[data-timeline-item]'));
    this.movingImage = section.querySelector('[data-timeline-image]');

    if (!this.timeline || !this.items.length || !this.movingImage) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.measure();
    this.update();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onResize);
  }

  measure() {
    const rect = this.timeline.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    this.timelineTop = rect.top + scrollTop;
    this.timelineHeight = this.timeline.offsetHeight;
    this.imageHeight = this.movingImage.offsetHeight || 0;
    this.maxImageY = Math.max(this.timelineHeight - this.imageHeight, 0);
  }

  update() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;
    const viewportCenter = scrollTop + viewportHeight * 0.5;

    const start = this.timelineTop;
    const end = this.timelineTop + this.timelineHeight;

    let progress = (viewportCenter - start) / (end - start);
    progress = Math.max(0, Math.min(1, progress));

    const imageY = progress * this.maxImageY;
    this.movingImage.style.transform = `translate(-50%, ${imageY}px)`;

    let activeIndex = 0;
    let closestDistance = Infinity;

    this.items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.top + rect.height / 2;
      const distance = Math.abs(itemCenter - viewportHeight / 2);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeIndex = index;
      }
    });

    this.items.forEach((item, index) => {
      item.classList.toggle('is-active', index === activeIndex);
    });
  }

  onScroll() {
    this.update();
  }

  onResize() {
    this.measure();
    this.update();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-timeline-section]').forEach((section) => {
    if (!section.timelineInstance) {
      section.timelineInstance = new AlternatingTimeline(section);
    }
  });
});